import { useEffect, useState } from "react";
import { Button, DatePicker, Space, Tooltip } from "antd";
import createAxiosInstanceNew from "../../../Api/AxiosInstance/AxiosInstance";
import { RedoOutlined, SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { UseAdmin } from "../../../hooks";

const { RangePicker } = DatePicker;

const flagsGenerateInitialStates = {
  isInactive: true,
  message: " Consulta por fechas para generar",
};

const WeekSelectBitacora = (props) => {
  const { setFaltantes } = props;
  const { branchFiPaisId, brandfiMarcaId } = UseAdmin();

  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });
  const [loading, setLoading] = useState(false);

  const [flagsConsult, setFlagsConsult] = useState({
    isInactive: false,
    message: "Elige rango de fecha.",
  });
  const [flagsGenerate, setFlagsGenerate] = useState(flagsGenerateInitialStates);

  const onChange = (dateString) => {
    setDate({
      startDate: dateString[0],
      endDate: dateString[1],
    });
  };

  const handleOnClick = async (date, isRefresh = false) => {
    if (isRefresh) {
      onChange(["", ""]);
    }
    try {
      setLoading(true);
      const axiosInstance = await createAxiosInstanceNew();
      const res = await axiosInstance.get(`faltante/bitacora`, {
        params: {
          FIPAISID: 1,
          FIMARCAID: 6,
          ...(!isRefresh && {
            FDFECHAINICIO: date.startDate,
            FDFECHAFIN: date.endDate,
          }),
        },
      });
      if (res.status === 200) {
        setFaltantes(res.data.body);
        if (!isRefresh) {
          setFlagsConsult({
            isInactive: true,
            message: "Elige otro rango de fecha o recarga.",
          });
        }

        if (res.data.body.length > 0) {
          if (!isRefresh) {
            setFlagsGenerate({
              isInactive: false,
              message: "",
            });
          } else {
            setFlagsGenerate(flagsGenerateInitialStates);
          }
        } else {
          setFlagsGenerate({
            isInactive: true,
            message: "No hay datos para generar.",
          });
        }
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (date.startDate && date.endDate) {
      setFlagsConsult({
        isInactive: false,
        message: "",
      });
    } else {
      setFlagsConsult({
        isInactive: true,
        message: "Elige rango de fecha.",
      });
    }
  }, [date]);

  const handleOnDownload = async () => {
    try {
      setLoading(true);
      const axiosInstance = await createAxiosInstanceNew();
      const res = await axiosInstance.get(`faltante/reporte/bitacora`, {
        params: {
          FIPAISID: branchFiPaisId,
          FIMARCAID: brandfiMarcaId,
          ...(date.startDate &&
            date.endDate && {
              FDFECHAINICIO: date.startDate,
              FDFECHAFIN: date.endDate,
            }),
        },
      });

      if (res.status === 200 && res.data.success) {
        console.log(res.data);

        const fileUrl = res.data.body;

        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "reporte.csv");
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
      } else {
        console.error("Error: No se pudo generar el reporte.");
      }
    } catch (error) {
      console.error("Error al obtener los datos:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="filter-row">
      <div className="filter-controls-container">
        <Tooltip title="Recargar">
          <button
            type="default"
            onClick={() => {
              handleOnClick(date, true);
            }}
            loading={loading}
            className="btn-toggle"
          >
            {loading ? null : (
              <RedoOutlined
                style={{
                  fontSize: "20px",
                }}
              />
            )}
          </button>
        </Tooltip>

        <RangePicker
          value={
            date.startDate && date.endDate ? [dayjs(date.startDate), dayjs(date.endDate)] : null
          }
          placeholder={["Fecha inicial", "Fecha final"]}
          onChange={(dates, dateString) => {
            onChange(dateString);
          }}
          allowClear={false}
          disabledDate={(current) => {
            return current && current > dayjs().endOf("day");
          }}
          className="range-picker"
        />
      </div>

      {/* btns */}
      <div className="filter-button-container">
        <Tooltip title={flagsConsult.message}>
          <button
            className="btn-search"
            type="primary"
            onClick={() => {
              handleOnClick(date);
            }}
            disabled={flagsConsult.isInactive || loading}
            loading={loading}
          >
            <SearchOutlined />
          </button>
        </Tooltip>

        <Tooltip title={flagsGenerate.message}>
          <button
            className="btn-toggle"
            type="primary"
            onClick={handleOnDownload}
            disabled={loading || flagsGenerate.isInactive}
            loading={loading}
          >
            CSV
          </button>
        </Tooltip>
      </div>
    </div>
  );
};
export default WeekSelectBitacora;
